export const songs = [
  {
    id: 1,
    title: {
      de: 'Ruf der Tat',
      ru: 'Зов дела'
    },
    category: 'heroic',
    description: {
      de: 'Ein heroisches Lied über Mut, Entschlossenheit und den Willen, Großes zu vollbringen.',
      ru: 'Героическая песня о мужестве, решимости и воле совершать великие дела.'
    },
    verse: {
      de: 'Wenn die Stunde ruft zum Handeln, / Wenn der Mut die Seele lenkt, / Dann erheben sich die Wandeln, / Die das Schicksal uns geschenkt.',
      ru: 'Когда час зовет к действию, / Когда мужество ведет душу, / Тогда поднимаются странники, / Которых судьба нам подарила.'
    },
    inspiration: 'Hölderlin',
    cover: 'https://public.readdy.ai/ai/img_res/4f996e8295e891d69e9a888d54a97cd5.jpg',
    duration: '4:32'
  },
  {
    id: 2,
    title: {
      de: 'Stille Wasser',
      ru: 'Тихие воды'
    },
    category: 'philosophical',
    description: {
      de: 'Eine philosophische Betrachtung über die Tiefe des Lebens und die Weisheit der Stille.',
      ru: 'Философское размышление о глубине жизни и мудрости тишины.'
    },
    verse: {
      de: 'Stille Wasser, tief und klar, / Spiegeln wider, was einst war, / In der Ruhe liegt die Kraft, / Die das Leben neu erschafft.',
      ru: 'Тихие воды, глубокие и ясные, / Отражают то, что было, / В покое лежит сила, / Которая создает жизнь заново.'
    },
    inspiration: 'Rilke',
    cover: 'https://readdy.ai/api/search-image?query=Peaceful%20lake%20with%20perfect%20mirror%20reflection%20of%20mountains%20and%20sky%20at%20dawn%2C%20serene%20atmosphere%2C%20minimalist%20composition%2C%20soft%20pastel%20colors%2C%20contemplative%20mood%2C%20simple%20natural%20background&width=400&height=500&seq=song-philosophical-1&orientation=portrait',
    duration: '5:18'
  },
  {
    id: 3,
    title: {
      de: 'Heimatklang',
      ru: 'Звук родины'
    },
    category: 'family',
    description: {
      de: 'Ein warmes Lied über Familie, Geborgenheit und die Kraft der Heimat.',
      ru: 'Теплая песня о семье, уюте и силе родины.'
    },
    verse: {
      de: 'Wo die Herzen sich vereinen, / Wo die Liebe Wurzeln schlägt, / Dort wird niemals einer weinen, / Der die Heimat in sich trägt.',
      ru: 'Где сердца объединяются, / Где любовь пускает корни, / Там никогда не будет плакать тот, / Кто носит родину в себе.'
    },
    inspiration: 'Eichendorff',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20family%20home%20with%20warm%20glowing%20windows%20at%20twilight%2C%20smoke%20from%20chimney%2C%20peaceful%20countryside%20setting%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20light%2C%20simple%20rustic%20background&width=400&height=500&seq=song-family-1&orientation=portrait',
    duration: '3:45'
  },
  {
    id: 4,
    title: {
      de: 'Mondnacht',
      ru: 'Лунная ночь'
    },
    category: 'romantic',
    description: {
      de: 'Eine romantische Ballade über Sehnsucht, Liebe und die Magie der Nacht.',
      ru: 'Романтическая баллада о тоске, любви и магии ночи.'
    },
    verse: {
      de: 'Es war, als hätt der Himmel / Die Erde still geküsst, / Dass sie im Blütenschimmer / Von ihm nun träumen müsst.',
      ru: 'Казалось, небо / Тихо поцеловало землю, / Чтобы она в сиянии цветов / Теперь должна была мечтать о нем.'
    },
    inspiration: 'Eichendorff',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20moonlit%20night%20scene%20with%20full%20moon%20over%20tranquil%20landscape%2C%20silhouettes%20of%20lovers%2C%20dreamy%20atmosphere%2C%20soft%20blue%20and%20silver%20tones%2C%20ethereal%20mood%2C%20simple%20elegant%20background&width=400&height=500&seq=song-romantic-1&orientation=portrait',
    duration: '4:15'
  },
  {
    id: 5,
    title: {
      de: 'Der Wanderer',
      ru: 'Странник'
    },
    category: 'philosophical',
    description: {
      de: 'Ein Lied über die Reise des Lebens, Selbstfindung und innere Freiheit.',
      ru: 'Песня о путешествии жизни, самопознании и внутренней свободе.'
    },
    verse: {
      de: 'Ich wandre durch die stille Nacht, / Da schleicht der Mond so heimlich sacht, / Oft denk ich an vergangne Zeit, / Und an die alte Herrlichkeit.',
      ru: 'Я брожу сквозь тихую ночь, / Луна крадется так тайно и тихо, / Часто думаю о прошедшем времени, / И о старой славе.'
    },
    inspiration: 'Goethe',
    cover: 'https://readdy.ai/api/search-image?query=Solitary%20traveler%20with%20walking%20stick%20on%20winding%20path%20through%20misty%20mountains%2C%20contemplative%20journey%2C%20atmospheric%20perspective%2C%20muted%20earth%20tones%2C%20philosophical%20mood%2C%20simple%20natural%20background&width=400&height=500&seq=song-philosophical-2&orientation=portrait',
    duration: '5:02'
  },
  {
    id: 6,
    title: {
      de: 'Frühlingserwachen',
      ru: 'Пробуждение весны'
    },
    category: 'romantic',
    description: {
      de: 'Eine lebendige Hymne an die Erneuerung, Hoffnung und die Schönheit des Frühlings.',
      ru: 'Живой гимн обновлению, надежде и красоте весны.'
    },
    verse: {
      de: 'Wenn die ersten Knospen springen, / Wenn die Vögel wieder singen, / Dann erwacht die Welt aufs Neu, / Voller Hoffnung, licht und treu.',
      ru: 'Когда первые почки распускаются, / Когда птицы снова поют, / Тогда мир просыпается заново, / Полный надежды, светлый и верный.'
    },
    inspiration: 'Mörike',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20spring%20meadow%20with%20blooming%20flowers%20and%20blossoming%20trees%2C%20fresh%20morning%20light%2C%20vibrant%20colors%2C%20renewal%20atmosphere%2C%20joyful%20mood%2C%20simple%20natural%20background&width=400&height=500&seq=song-romantic-2&orientation=portrait',
    duration: '3:28'
  },
  {
    id: 7,
    title: {
      de: 'Brüder im Geiste',
      ru: 'Братья по духу'
    },
    category: 'heroic',
    description: {
      de: 'Ein kraftvolles Lied über Kameradschaft, Treue und gemeinsame Ideale.',
      ru: 'Мощная песня о товариществе, верности и общих идеалах.'
    },
    verse: {
      de: 'Seht, wie wir zusammenstehen, / Brüder fest in Treu und Pflicht, / Werden niemals untergehen, / Denn uns eint ein helles Licht.',
      ru: 'Смотрите, как мы стоим вместе, / Братья крепко в верности и долге, / Никогда не погибнем, / Ибо нас объединяет яркий свет.'
    },
    inspiration: 'Schiller',
    cover: 'https://readdy.ai/api/search-image?query=Group%20of%20warriors%20standing%20together%20in%20unity%20on%20hilltop%20at%20sunset%2C%20brotherhood%20symbolism%2C%20strong%20composition%2C%20warm%20heroic%20lighting%2C%20inspiring%20atmosphere%2C%20simple%20dramatic%20background&width=400&height=500&seq=song-heroic-2&orientation=portrait',
    duration: '4:48'
  },
  {
    id: 8,
    title: {
      de: 'Am Kamin',
      ru: 'У камина'
    },
    category: 'family',
    description: {
      de: 'Ein gemütliches Lied über Familienabende, Wärme und gemeinsame Erinnerungen.',
      ru: 'Уютная песня о семейных вечерах, тепле и общих воспоминаниях.'
    },
    verse: {
      de: 'Am Kamin, da sitzt die Runde, / Erzählt von alter, guter Zeit, / Jede Stunde, jede Stunde, / Schenkt uns neue Heiterkeit.',
      ru: 'У камина сидит круг, / Рассказывает о старом, добром времени, / Каждый час, каждый час, / Дарит нам новую радость.'
    },
    inspiration: 'Storm',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20fireplace%20with%20warm%20glowing%20flames%2C%20comfortable%20armchairs%2C%20family%20gathering%20atmosphere%2C%20intimate%20lighting%2C%20nostalgic%20mood%2C%20simple%20rustic%20interior%20background&width=400&height=500&seq=song-family-2&orientation=portrait',
    duration: '3:52'
  },
  {
    id: 9,
    title: {
      de: 'Sternennacht',
      ru: 'Звездная ночь'
    },
    category: 'philosophical',
    description: {
      de: 'Eine meditative Betrachtung über Unendlichkeit, Kosmos und unseren Platz im Universum.',
      ru: 'Медитативное размышление о бесконечности, космосе и нашем месте во вселенной.'
    },
    verse: {
      de: 'Unter Sternen, weit und klar, / Fühlt die Seele, was sie war, / Ewigkeit im Augenblick, / Führt uns zu uns selbst zurück.',
      ru: 'Под звездами, далекими и ясными, / Душа чувствует, чем она была, / Вечность в мгновении, / Ведет нас обратно к себе.'
    },
    inspiration: 'Novalis',
    cover: 'https://readdy.ai/api/search-image?query=Magnificent%20starry%20night%20sky%20with%20milky%20way%20over%20silhouette%20landscape%2C%20cosmic%20wonder%2C%20deep%20blue%20and%20purple%20tones%2C%20contemplative%20atmosphere%2C%20simple%20natural%20background&width=400&height=500&seq=song-philosophical-3&orientation=portrait',
    duration: '5:35'
  },
  {
    id: 10,
    title: {
      de: 'Liebesbrief',
      ru: 'Любовное письмо'
    },
    category: 'romantic',
    description: {
      de: 'Eine zärtliche Liebeserklärung in Versen, voller Sehnsucht und Hingabe.',
      ru: 'Нежное признание в любви в стихах, полное тоски и преданности.'
    },
    verse: {
      de: 'Mein Herz schreibt dir in jeder Zeile, / Was Worte kaum zu sagen wagen, / In Liebe, ohne Arg und Eile, / Will ich dir meine Seele tragen.',
      ru: 'Мое сердце пишет тебе в каждой строке, / То, что слова едва осмеливаются сказать, / В любви, без хитрости и спешки, / Я хочу нести тебе свою душу.'
    },
    inspiration: 'Heine',
    cover: 'https://readdy.ai/api/search-image?query=Vintage%20love%20letter%20with%20quill%20pen%20and%20red%20rose%20on%20antique%20desk%2C%20romantic%20candlelight%2C%20intimate%20atmosphere%2C%20warm%20sepia%20tones%2C%20tender%20mood%2C%20simple%20elegant%20background&width=400&height=500&seq=song-romantic-3&orientation=portrait',
    duration: '4:05'
  },
  {
    id: 11,
    title: {
      de: 'Sturmwind',
      ru: 'Штормовой ветер'
    },
    category: 'heroic',
    description: {
      de: 'Ein dynamisches Lied über Herausforderungen, Widerstand und unbeugsamen Willen.',
      ru: 'Динамичная песня о вызовах, сопротивлении и несгибаемой воле.'
    },
    verse: {
      de: 'Wenn der Sturmwind wild uns treibt, / Wenn die Welt in Aufruhr bleibt, / Stehen wir wie Felsen fest, / Trotzen jedem Wettertest.',
      ru: 'Когда штормовой ветер дико гонит нас, / Когда мир остается в смятении, / Мы стоим твердо, как скалы, / Бросаем вызов любому испытанию погоды.'
    },
    inspiration: 'Puschkin',
    cover: 'https://readdy.ai/api/search-image?query=Powerful%20storm%20with%20dramatic%20clouds%20and%20lightning%20over%20rocky%20coastline%2C%20lone%20figure%20standing%20strong%2C%20dynamic%20composition%2C%20intense%20atmosphere%2C%20simple%20dramatic%20background&width=400&height=500&seq=song-heroic-3&orientation=portrait',
    duration: '4:22'
  },
  {
    id: 12,
    title: {
      de: 'Generationen',
      ru: 'Поколения'
    },
    category: 'family',
    description: {
      de: 'Ein bewegendes Lied über die Verbindung zwischen Generationen und das Erbe der Familie.',
      ru: 'Трогательная песня о связи между поколениями и семейном наследии.'
    },
    verse: {
      de: 'Von Großvater zu Enkel fließt, / Was Zeit und Raum zusammenschließt, / Die Weisheit alter Tage spricht, / In jedem jungen Angesicht.',
      ru: 'От дедушки к внуку течет, / То, что соединяет время и пространство, / Мудрость старых дней говорит, / В каждом молодом лице.'
    },
    inspiration: 'Fontane',
    cover: 'https://readdy.ai/api/search-image?query=Three%20generations%20family%20portrait%20with%20grandfather%2C%20father%20and%20child%20together%2C%20warm%20connection%2C%20timeless%20atmosphere%2C%20soft%20natural%20lighting%2C%20heritage%20theme%2C%20simple%20elegant%20background&width=400&height=500&seq=song-family-3&orientation=portrait',
    duration: '4:40'
  },
  {
    id: 13,
    title: {
      de: 'Herbstgedanken',
      ru: 'Осенние мысли'
    },
    category: 'philosophical',
    description: {
      de: 'Eine melancholische Reflexion über Vergänglichkeit, Reife und die Schönheit des Abschieds.',
      ru: 'Меланхоличное размышление о бренности, зрелости и красоте прощания.'
    },
    verse: {
      de: 'Wenn die Blätter golden fallen, / Wenn der Herbstwind leise weht, / Hör ich ferne Stimmen hallen, / Die von Ewigkeit erzählt.',
      ru: 'Когда листья золотом падают, / Когда осенний ветер тихо дует, / Я слышу далекие голоса эхом, / Которые рассказывают о вечности.'
    },
    inspiration: 'Trakl',
    cover: 'https://readdy.ai/api/search-image?query=Autumn%20forest%20path%20covered%20with%20golden%20fallen%20leaves%2C%20melancholic%20atmosphere%2C%20warm%20amber%20and%20orange%20tones%2C%20contemplative%20mood%2C%20misty%20background%2C%20simple%20natural%20setting&width=400&height=500&seq=song-philosophical-4&orientation=portrait',
    duration: '5:10'
  },
  {
    id: 14,
    title: {
      de: 'Ewiger Bund',
      ru: 'Вечный союз'
    },
    category: 'romantic',
    description: {
      de: 'Eine feierliche Liebesballade über ewige Treue und unzerbrechliche Verbindung.',
      ru: 'Торжественная любовная баллада о вечной верности и нерушимой связи.'
    },
    verse: {
      de: 'Zwei Seelen, die sich einst gefunden, / In Liebe fest zusammengebunden, / Durch alle Zeit, durch jeden Raum, / Erfüllen sie den schönsten Traum.',
      ru: 'Две души, которые когда-то нашли друг друга, / В любви крепко связанные вместе, / Через все время, через каждое пространство, / Исполняют они самую прекрасную мечту.'
    },
    inspiration: 'Achmatowa',
    cover: 'https://readdy.ai/api/search-image?query=Two%20intertwined%20wedding%20rings%20on%20vintage%20lace%20with%20soft%20rose%20petals%2C%20eternal%20love%20symbolism%2C%20romantic%20lighting%2C%20warm%20golden%20tones%2C%20intimate%20atmosphere%2C%20simple%20elegant%20background&width=400&height=500&seq=song-romantic-4&orientation=portrait',
    duration: '4:58'
  },
  {
    id: 15,
    title: {
      de: 'Morgenrot',
      ru: 'Утренняя заря'
    },
    category: 'heroic',
    description: {
      de: 'Ein inspirierendes Lied über Neuanfang, Hoffnung und den Mut zum ersten Schritt.',
      ru: 'Вдохновляющая песня о новом начале, надежде и смелости сделать первый шаг.'
    },
    verse: {
      de: 'Wenn das Morgenrot erwacht, / Und die Nacht dem Tag weicht, / Wird die Welt neu entfacht, / Und das Herz wird leicht.',
      ru: 'Когда утренняя заря просыпается, / И ночь уступает дню, / Мир зажигается заново, / И сердце становится легким.'
    },
    inspiration: 'Körner',
    cover: 'https://readdy.ai/api/search-image?query=Spectacular%20sunrise%20over%20mountain%20peaks%20with%20dramatic%20red%20and%20orange%20sky%2C%20new%20beginning%20symbolism%2C%20inspiring%20composition%2C%20warm%20vibrant%20colors%2C%20hopeful%20atmosphere%2C%20simple%20natural%20background&width=400&height=500&seq=song-heroic-4&orientation=portrait',
    duration: '3:55'
  },
  {
    id: 16,
    title: {
      de: 'Kinderlachen',
      ru: 'Детский смех'
    },
    category: 'family',
    description: {
      de: 'Ein fröhliches Lied über die Unschuld der Kindheit und die Freude des Familienlebens.',
      ru: 'Веселая песня о невинности детства и радости семейной жизни.'
    },
    verse: {
      de: 'Kinderlachen, hell und rein, / Bringt uns Sonnenschein hinein, / In die Herzen, groß und klein, / Lässt uns wieder Kinder sein.',
      ru: 'Детский смех, светлый и чистый, / Приносит нам солнечный свет, / В сердца, большие и маленькие, / Позволяет нам снова быть детьми.'
    },
    inspiration: 'Rückert',
    cover: 'https://readdy.ai/api/search-image?query=Happy%20children%20playing%20and%20laughing%20in%20sunny%20garden%20with%20flowers%2C%20joyful%20innocence%2C%20bright%20cheerful%20colors%2C%20warm%20family%20atmosphere%2C%20simple%20natural%20background&width=400&height=500&seq=song-family-4&orientation=portrait',
    duration: '3:18'
  },
  {
    id: 17,
    title: {
      de: 'Weisheit der Jahre',
      ru: 'Мудрость лет'
    },
    category: 'philosophical',
    description: {
      de: 'Eine tiefgründige Meditation über Lebenserfahrung, Alter und gewonnene Erkenntnisse.',
      ru: 'Глубокая медитация о жизненном опыте, возрасте и полученных знаниях.'
    },
    verse: {
      de: 'Was die Jahre uns gelehrt, / Hat die Seele tief genährt, / Jede Falte erzählt Geschichte, / Von Weisheit und vom Lichte.',
      ru: 'То, чему годы нас научили, / Глубоко питало душу, / Каждая морщина рассказывает историю, / О мудрости и о свете.'
    },
    inspiration: 'Goethe',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20wise%20oak%20tree%20with%20deep%20roots%20and%20spreading%20branches%2C%20wisdom%20symbolism%2C%20timeless%20atmosphere%2C%20earthy%20natural%20tones%2C%20contemplative%20mood%2C%20simple%20natural%20background&width=400&height=500&seq=song-philosophical-5&orientation=portrait',
    duration: '5:25'
  },
  {
    id: 18,
    title: {
      de: 'Sehnsucht',
      ru: 'Тоска'
    },
    category: 'romantic',
    description: {
      de: 'Eine gefühlvolle Ballade über Verlangen, Fernweh und die Suche nach dem Geliebten.',
      ru: 'Чувственная баллада о желании, тоске по дальним странам и поиске любимого.'
    },
    verse: {
      de: 'Es schläft ein Lied in allen Dingen, / Die träumend um uns sind, / Und die Welt hebt an zu singen, / Triffst du nur das Zauberwort.',
      ru: 'Спит песня во всех вещах, / Которые мечтательно вокруг нас, / И мир начинает петь, / Если ты найдешь только волшебное слово.'
    },
    inspiration: 'Eichendorff',
    cover: 'https://readdy.ai/api/search-image?query=Solitary%20figure%20gazing%20at%20distant%20horizon%20over%20vast%20landscape%2C%20longing%20symbolism%2C%20dreamy%20atmosphere%2C%20soft%20pastel%20colors%2C%20romantic%20melancholy%2C%20simple%20natural%20background&width=400&height=500&seq=song-romantic-5&orientation=portrait',
    duration: '4:33'
  }
];
